import {Injectable} from '@angular/core';
import {PostPayloadInterface} from '../utilities/post-payload.interface';
import { HttpClient } from '@angular/common/http';

import {BaseRepository, PositoryErrorHandlerService, Path, RepoPath} from 'ng-pository';
import {Contract} from '../models/contract.model';

@RepoPath('/mgmt/distributor/contracts')
@Injectable({
  providedIn: 'root'
})
export class ContractDistributorRepository extends BaseRepository<PostPayloadInterface> {

  constructor(httpClient: HttpClient, errorhandler: PositoryErrorHandlerService) {
    super(httpClient, errorhandler);
  }

  @Path('/{distributorId}/by-distributor?deleted={deleted}')
  getAllByDeleted(distributorId:number,deleted: boolean) {
    return super.get();
  }

  @Path('/{distributorId}/measuring-points/{pointId}/measuring-devices/{deviceId}')
  getAllByMeasuringDeviceIdOrMeasuringPointId(distributorId:number,pointId: number, deviceId: number) {
    return super.get();
  }

  @Path('/{id}')
  getById(id: number) {
    return super.get();
  }

  save(contract: Contract) {
    return super.post({
      type: 'Add',
      id: 0,
      attribute: contract
    });
  }

  @Path('/{id}')
  deleteById(id: string) {
    return super.delete();
  }

  @Path('/{id}/unlock')
  adminUnlock(id: number) {
    return super.patch();
  }
  @Path('/{id}/interval')
  updateInterval(id: number, dto:any) {
    return super.patch(dto);
  }
  @Path('/{id}/measuring-devices/{deviceId}')
  updateDevice(id: number,deviceId:number) {
    return super.patch();
  }
  @Path('/{id}/measuring-points/{pointId}')
  updatePoint(id: number,pointId:number) {
    return super.patch();
  }
  @Path('/{id}/partners')
  updatePartner(id: number,dto:any) {
    return super.patch(dto);
  }
}

